import { QrCode, Heart, User, X } from 'lucide-react'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePageTitle } from '../../hooks/usePageTitle'
import QRCode from 'qrcode'

const UserScan = () => {
  usePageTitle()
  const navigate = useNavigate()
  const [showIdCardModal, setShowIdCardModal] = useState(false)
  const [qrDataUrl, setQrDataUrl] = useState('')

  // 登录守卫
  useEffect(() => {
    if (!localStorage.getItem('token')) {
      navigate('/user/login')
    }
  }, [navigate])
  const userAccount = JSON.parse(localStorage.getItem('userAccount') || '{}')
  const user = userAccount || { id: '', name: '', phone: '', idCard: '' }
  // 二维码内容：仅存储用户ID，小程序扫码页面解析后跳转
  const userId = user.id || userAccount.id || ''

  // 本地生成二维码
  useEffect(() => {
    if (userId) {
      QRCode.toDataURL(userId, {
        width: 256,
        margin: 2,
        color: { dark: '#15803d', light: '#f0fdf4' }  // 绿色风格
      }).then(url => setQrDataUrl(url))
    }
  }, [userId])

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* 顶部区域 */}
      <div className="bg-gradient-to-br from-green-600 to-green-700 px-4 pt-6 pb-8">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <Heart className="w-6 h-6 text-white" />
            <span className="text-white font-bold">身份码</span>
          </div>
        </div>

        <p className="text-green-100 text-sm text-center">
          出示此二维码，医护人员扫描后可快速识别您的身份
        </p>
      </div>

      {/* 二维码区域 */}
      <div className="px-4 -mt-6">
        <div className="bg-white rounded-2xl shadow-lg p-6">
          <div className="flex flex-col items-center">
            {/* 用户信息 */}
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <User className="w-6 h-6 text-green-600" />
              </div>
              <div>
                <p className="font-bold text-gray-800">{user.name}</p>
                <p className="text-sm text-gray-500">{user.phone}</p>
                {user.idCard && (
                  <p className="text-xs text-gray-400 mt-0.5">
                    身份证：{user.idCard.replace(/(\d{4})\d{6}(\d{4})/, '****$2')}
                  </p>
                )}
              </div>
            </div>

            {/* 二维码 */}
            <div className="relative">
              <div className="w-64 h-64 bg-green-50 rounded-2xl flex items-center justify-center overflow-hidden">
                {qrDataUrl ? (
                  <img
                    src={qrDataUrl}
                    alt="身份二维码"
                    className="w-full h-full object-contain"
                  />
                ) : (
                  <div className="flex items-center justify-center">
                    <svg className="animate-spin h-8 w-8 text-green-600" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                  </div>
                )}
              </div>
              {/* 装饰角标 */}
              <div className="absolute -top-2 -left-2 w-8 h-8 bg-green-600 rounded-lg flex items-center justify-center">
                <QrCode className="w-5 h-5 text-white" />
              </div>
              <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center">
                <Heart className="w-5 h-5 text-white" />
              </div>
            </div>

            {/* 提示文字 */}
            <p className="text-center text-gray-500 text-sm mt-6">
              健康积分 专属身份码
            </p>
            {/* 机构信息 */}
            {userAccount?.hospitalName && (
              <p className="text-center text-green-600 text-xs mt-2 font-medium">
                {userAccount.hospitalName}
              </p>
            )}
            <p className="text-center text-gray-400 text-xs mt-1">
              请出示给医护人员扫描
            </p>
          </div>
        </div>
      </div>

      {/* 使用说明 */}
      <div className="px-4 mt-6">
        <div className="bg-white rounded-2xl shadow-md p-6">
          <h3 className="font-bold text-gray-800 mb-4">使用说明</h3>
          <div className="space-y-4">
            <div className="flex items-start">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                <span className="text-green-700 font-bold text-sm">1</span>
              </div>
              <div>
                <p className="font-medium text-gray-800">打开身份码</p>
                <p className="text-sm text-gray-500 mt-1">
                  在"我的"页面或个人中心点击"我的身份码"
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                <span className="text-green-700 font-bold text-sm">2</span>
              </div>
              <div>
                <p className="font-medium text-gray-800">出示给医护人员</p>
                <p className="text-sm text-gray-500 mt-1">
                  在医疗机构接受服务时，向医护人员出示此二维码
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                <span className="text-green-700 font-bold text-sm">3</span>
              </div>
              <div>
                <p className="font-medium text-gray-800">自动获得积分</p>
                <p className="text-sm text-gray-500 mt-1">
                  医护人员扫描后，您的健康活动将自动记录并获得积分
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 注意事项 */}
      <div className="px-4 mt-4">
        <div className="bg-orange-50 rounded-xl p-4">
          <p className="text-sm text-orange-700">
            <strong>注意：</strong>此二维码为您的唯一身份标识，请勿泄露给他人。
            如有疑问，请联系客服。
          </p>
        </div>
      </div>

      {/* 身份证未设置弹窗 */}
      {!user.idCard && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-sm mx-4 overflow-hidden">
            <div className="p-6 text-center">
              <p className="text-gray-600 mb-6">暂未设置身份证号，不支持该功能</p>
              <button onClick={() => navigate('/user/personal-info')}
                className="w-full py-3 bg-green-600 text-white rounded-xl font-medium hover:bg-green-700">
                立即设置
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default UserScan
